import { Injectable, Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AuthService } from '../shared/auth.service';
import { AccountService } from '../shared/account.service';
import { BackendService } from '../shared/backend.service';
import CONFIG from '../../config';
import { DecimalPipe } from '@angular/common';
// import { PositionsComponent } from '../menu/positions/positions.component';
import { Subscription } from 'rxjs/Subscription';
import { AccountactivityService } from 'app/accountactivity/accountactivity.service';
import { MultiColumnGridService } from 'app/shared/multi-column-grid.service';
import { ContactUsDialogComponent } from '../contact-us/contact-us.component';
import { MatDialog , MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AppService } from 'app/app.service';
@Component({
    providers: [
        DecimalPipe,
        // PositionsComponent
    ],
    selector: 'dashboard-component',
    templateUrl: './dashboard.component.html',
    styles: [`
        .body-container {
            padding-bottom: 5rem;
        }
        .footer {
            width: 100%;
            padding: 1em;
            // background-color: #f7f7f9;
            // background-color:rgb(79, 174, 239);
            //background-color:rgb(37, 145, 217);
            box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.16);
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: absolute;
            bottom: 0;
            right: 0;
            left: 0;
        }
        .footer a {
            color: inherit;
        }
        .footer .fa {
            transition: color 0.2s ease-in-out;
        }
        .twitter:hover {
            color: #1da1f2;
        }
        .facebook:hover {
            color: #3b5998;
        }
        .linkedin:hover {
            color: #0077b5;
        }
  `]
})
@Injectable()
export class DashboardComponent implements OnInit, OnDestroy, AfterViewInit {
    currentSettlementAccountSubscription: Subscription;
    dropdownOpen: boolean = false;
    headerHeight: String;
    AccountName: string = '';
    LoginType: string = '';
    totalEntries: number = 0;
    accounts: any;
    accountnumber: string;
    scc: any;
    grid: any;
    originalItems: Object[] = [];
    @ViewChild('dashWrapper') dash;
    currentYear: number;
    activeSettlementAccount = 'Select account';
    Customertype:any;
    animal: string;
    name: string;

    constructor(
        public dialog: MatDialog,
        public decimalPipe: DecimalPipe,
        // public comp: PositionsComponent,
        public formBuilder: FormBuilder,
        public backendService: BackendService,
        public authService: AuthService,
        public accountService: AccountService,
        //public accountActitvityService:AccountactivityService,
        public _appService:AppService,
        public _authService: AuthService
    ) { this.accountnumber = ""; }

    ngOnInit() {

        this._appService.setUserLoggedIn(true);
        this.currentSettlementAccountSubscription = this.accountService.currentSettlementAccountChange$.subscribe(currentSettlementAccount => this.currentSettlementAccountChange(currentSettlementAccount));

        //this.getAccountsDropdowns();
        this.LoginType = localStorage.getItem('LoginType') || sessionStorage.getItem('LoginType');
        this.AccountName = localStorage.getItem('CustomerID') || sessionStorage.getItem('CustomerID');
        this.Customertype= localStorage.getItem('CustomerType') || sessionStorage.getItem('CustomerType');
        //console.log(this.Customertype);
        this.currentYear = new Date().getFullYear();
    }
    ngOnDestroy() {
        if(this.currentSettlementAccountSubscription) { this.currentSettlementAccountSubscription.unsubscribe(); }
    }
    currentSettlementAccountChange(value){
      
        this.activeSettlementAccount = value;
    }
    public callMe(): void {
        // this.comp.filterAuditLog();
    }
    contactUS(): void {
        //console.log('contactUSSS');
        let dialogRef = this.dialog.open(ContactUsDialogComponent, {
          width: '70%',
          data: { name: this.name, animal: this.animal }
        })
    
        dialogRef.afterClosed().subscribe(result => {
         // console.log('The dialog was closed');
          this.animal = result;
        })
      }

    filterAuditLog(item) {
        this.scc = item;
        let stringToSplit = this.scc;
        let x = stringToSplit.split("_");
        let value = x[0];
        //console.log("entered filter");

        // this.backendService.getData(`${CONFIG.positionsApiUrlBase}/${this.authService.CustomerID}`)
        //     .subscribe(data => {
        //         this.grid = data['myCustomer'];

        //         this.originalItems = this.grid.filter(x => x.accountNumber === value);
        //         console.log(this.originalItems);
        //         this.grid = this.originalItems;
        //     });
        // this.comp.filterAuditLogForDashBoard(value);
        this.accountService.setSAccount(value);
    }
    resetAuditListing() {

        this.activeSettlementAccount = 'Select account';    
        this.accountService.setSAccount(this.activeSettlementAccount);
    }
    ngAfterViewInit() {
        this.headerHeight = `${this.dash.nativeElement.offsetHeight + 25}px`;
    }
    // getAccountsDropdowns() {
    //     this.backendService.getData(`${CONFIG.getAccountsDropdowns}/${this.authService.CustomerID}`)
    //         .subscribe(data => {
    //             this.accounts = data['accounts'];
    //             this.totalEntries = this.accounts.length;
    //         });
    // }

    // setValue(value: string) {
    //     this.accountnumber = value;
    // }

}    
